import { utilFormatDeliveryDate } from '@/util/format-delivery-date';
import { PickupPoint, PointsByType, PointType } from '@/util/map-point-maps/types';

export const getPointsByTypes = (
  points: PickupPoint[],
  pointTypes: PointType[]
): PointsByType[] => {
  const types = pointTypes;

  return types.map((type) => {
    return {
      type,
      points: points
        .filter((point) => point.type === type)
        .filter((point) => {
          const lng = Number(point.coords[1]);
          const lat = Number(point.coords[0]);
          return Number.isFinite(lng) && Number.isFinite(lat);
        })
        .map((point) => ({
          type: 'Feature',
          id: point.id.toString(),
          geometry: {
            type: 'Point',
            coordinates: [+point.coords[1], +point.coords[0]]
          },
          properties: {
            title: point.title,
            street: point.street,
            pointType: point.type,
            cost: point.cost,
            carrierName: point.carrierName,
            deliveryDate: utilFormatDeliveryDate(
              point?.deliveryDate ? point?.deliveryDate : ''
            ),
            openingHours: point.openingHours,
            phone: point.phone,
            metro: point?.metro,
            auto: point?.auto,
            image: point?.image,
            shopName: point?.shopName
          }
        }))
    };
  });
};
